import React from 'react';
import { useOutletContext } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { usePractitionerImportDataContext } from 'lib/context/PractitionerImportDataContext/PractitionerImportDataContext';
import { iaRa } from 'lib/helpers/utility';

import Select from 'components/shared/Select/Select';

import MultiStepForm from './form/MultiStepForm';

const DataSelector = () => {
  const { sourcePractice, setSourcePractice, targetPractices, setTargetPractices, dispatch } =
    usePractitionerImportDataContext();
  const queryClient = useQueryClient();
  const { practices } = useOutletContext();

  const handleSelectSourcePractice = (e) => {
    setTargetPractices([]);
    setSourcePractice(e);
    dispatch({ type: 'RESET_All_DATA' });
    queryClient.invalidateQueries(['locationImportData']);
  };

  const practiceOptions = iaRa(practices).map((practice) => ({
    value: practice.id,
    label: practice.name
  }));

  const practiceOptionToExportTo = practiceOptions.filter(
    (option) => option.value !== sourcePractice?.value
  );

  return (
    <div className="w-full !py-2 px-4">
      <div className="flex items-start gap-4 ">
        <Select
          options={practiceOptions}
          onChange={handleSelectSourcePractice}
          value={sourcePractice}
          parentClassName="w-1/2"
          placeholder="Type and select Location"
          label="Select Location from where to import data"
        />
        <Select
          options={practiceOptionToExportTo}
          onChange={(e) => setTargetPractices(e)}
          value={targetPractices}
          parentClassName="w-1/2"
          placeholder="Type and select Location"
          label="Select Location to export data to"
          isMulti
        />
      </div>

      {sourcePractice && <MultiStepForm />}
    </div>
  );
};

export default DataSelector;
